import { ZONE_SECURITY, ZONE_ROLES, ZONE_ADMIN } from 'garaje/utils/roles';
import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  roleName: () => faker.helpers.arrayElement(ZONE_ROLES),
  confirmedAt: () => faker.date.past(),
  lastSeenAt: () => faker.date.past(),

  asZoneSecurityAdmin: trait({
    roleName: ZONE_SECURITY,
  }),

  asZoneAdmin: trait({
    roleName: ZONE_ADMIN,
  }),
});
